/**
 * Utilidades de presentación de direcciones (solo lectura, sin transformar datos).
 */

/**
 * Versión resumida para el encabezado: solo tramo de calle.
 * Ignora barrio, comuna, provincia, región, código postal y país.
 *
 * Ejemplo:
 * "Entre Gallos, 514, Pedro Aguirre Cerda, Chillancito, Angol, Provincia de Malleco, Región de la Araucanía, 4350000, Chile"
 * → "Entre Gallos 514 · Pedro Aguirre Cerda"
 *
 * @param {string|null|undefined} direccion
 * @returns {string|null}
 */
export function formatearDireccionResumida(direccion) {
  const texto = String(direccion || "").trim();
  if (!texto) {
    return null;
  }

  let partes = texto
    .split(",")
    .map((parte) => parte.trim())
    .filter(Boolean);

  partes = quitarSufijoAdministrativo(partes);
  partes = quitarLocalidad(partes);

  if (partes.length === 0) {
    return null;
  }

  return formatearPartesCalle(partes);
}

/**
 * @param {string} segmento
 * @returns {boolean}
 */
function esSufijoAdministrativo(segmento) {
  return (
    /^chile$/i.test(segmento) ||
    /^\d{5,7}$/.test(segmento) ||
    /^regi[oó]n\b/i.test(segmento) ||
    /^provincia\b/i.test(segmento)
  );
}

/**
 * @param {string[]} partes
 * @returns {string[]}
 */
function quitarSufijoAdministrativo(partes) {
  const resultado = [...partes];

  while (
    resultado.length > 0 &&
    esSufijoAdministrativo(resultado[resultado.length - 1])
  ) {
    resultado.pop();
  }

  return resultado;
}

/**
 * Quita comuna y, si aplica, barrio al final de la dirección.
 *
 * @param {string[]} partes
 * @returns {string[]}
 */
function quitarLocalidad(partes) {
  if (partes.length < 2) {
    return partes;
  }

  const resultado = [...partes];
  const incluyeBarrio = resultado.length >= 5;

  resultado.pop();

  if (incluyeBarrio && resultado.length > 0) {
    resultado.pop();
  }

  return resultado;
}

/**
 * @param {string[]} partesCalle
 * @returns {string|null}
 */
function formatearPartesCalle(partesCalle) {
  if (partesCalle.length === 0) {
    return null;
  }

  if (partesCalle.length === 1) {
    return partesCalle[0];
  }

  const callePrincipal = extraerCalleConNumero(partesCalle);
  const referencia = [...partesCalle]
    .slice(1)
    .reverse()
    .find(
      (parte) =>
        !/^\d+[a-zA-Z]?$/.test(parte) && parte !== partesCalle[0]
    );

  if (referencia) {
    return `${callePrincipal} · ${referencia}`;
  }

  return callePrincipal;
}

/**
 * @param {string[]} partes
 * @returns {string}
 */
function extraerCalleConNumero(partes) {
  const calle = partes[0];
  const posibleNumero = partes[1];

  if (posibleNumero && /^\d+[a-zA-Z]?$/.test(posibleNumero)) {
    return `${calle} ${posibleNumero}`.trim();
  }

  return calle;
}
